import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const Stat = ({ label, value }) => (
  <div className="bg-white border border-admin-border p-6">
    <div className="text-[10px] tracking-overline uppercase text-cc-muted mb-2">{label}</div>
    <div className="font-serif text-4xl text-cc-text">{value ?? "—"}</div>
  </div>
);

export default function AdminDashboardPage() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState({ articles: [], leads: [] });

  useEffect(() => {
    (async () => {
      try {
        const [s, r] = await Promise.all([
          api.get("/admin/dashboard/stats"),
          api.get("/admin/dashboard/recent"),
        ]);
        setStats(s.data);
        setRecent(r.data);
      } catch {}
    })();
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-10">
        <h1 className="font-serif text-4xl text-cc-text mb-2">Genel Bakış</h1>
        <p className="text-sm text-cc-muted">Capella Cave platform durumu</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
        <Stat label="Yayınlanan" value={stats?.articles_published} />
        <Stat label="Taslak" value={stats?.articles_draft} />
        <Stat label="Ansiklopedi" value={stats?.encyclopedia_published} />
        <Stat label="Koleksiyon" value={stats?.collections_total} />
        <Stat label="İçerik Fikri" value={stats?.ideas_total} />
        <Stat label="Yazılıyor" value={stats?.ideas_writing} />
        <Stat label="Bekleyen Story" value={stats?.stories_pending} />
        <Stat label="Yaklaşan Etkinlik" value={stats?.events_upcoming} />
        <Stat label="Newsletter" value={stats?.leads_newsletter} />
        <Stat label="Kurucu Misafir" value={stats?.leads_founding} />
        <Stat label="Son 30 gün Lead" value={stats?.leads_last_30} />
        <Stat label="Medya" value={stats?.media_total} />
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-white border border-admin-border p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-medium text-cc-text">Son Yazılar</h3>
            <Link to="/admin/articles" className="text-xs text-cc-sepia">Tümü →</Link>
          </div>
          <ul className="space-y-3 text-sm">
            {recent.articles.map((a) => (
              <li key={a.id} className="flex items-center justify-between gap-3">
                <Link to={`/admin/articles/${a.id}`} className="flex-1 truncate hover:text-cc-sepia">
                  {a.translations?.tr?.title || "(başlıksız)"}
                </Link>
                <span className={`text-[10px] uppercase tracking-overline ${a.status === "published" ? "text-cc-sepia" : "text-cc-muted"}`}>{a.status}</span>
              </li>
            ))}
            {recent.articles.length === 0 && <li className="text-cc-muted text-sm">Henüz yazı yok.</li>}
          </ul>
        </div>

        <div className="bg-white border border-admin-border p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-medium text-cc-text">Son Lead'ler</h3>
            <Link to="/admin/leads" className="text-xs text-cc-sepia">Tümü →</Link>
          </div>
          <ul className="space-y-3 text-sm">
            {recent.leads.map((l) => (
              <li key={l.id} className="flex items-center justify-between gap-3">
                <div className="flex-1 truncate">
                  <span className="text-cc-text">{l.email}</span>
                  {l.name && <span className="text-cc-muted ml-2">{l.name}</span>}
                </div>
                <span className="text-[10px] uppercase tracking-overline text-cc-sepia">{l.type}</span>
              </li>
            ))}
            {recent.leads.length === 0 && <li className="text-cc-muted text-sm">Henüz lead yok.</li>}
          </ul>
        </div>
      </div>
    </div>
  );
}
